import SubmitButton, { SubmitButtonProps } from "@/components/SubmitButton";
import { Save } from "lucide-react";

type SaveButtonProps = Omit<SubmitButtonProps, "icon">;

function SaveButton(props: SaveButtonProps) {
  const icon = <Save className="mr-2 h-5 w-5" />;

  return <SubmitButton icon={icon} {...props} />;
}

export default SaveButton;
